import { multicastChannel } from 'redux-saga';
import ddt from '@wix/da-ddt';
import { CompliantCategories, LocalStorageCategoryTypeConfig } from './constants';
export const verifyAccessToLocalStorage = (key, privacyRequired, hasAcceptedCookies, acceptedCookieTypes)=>{
    const cookieType = LocalStorageCategoryTypeConfig[key];
    if (!cookieType) {
        ddt.error('compliantlocalstorage', `Attempted to access unregistered localStorage key: ${key}`);
        return false;
    }
    // allow access if user is not in a region where privacy compliancy is required
    if (!privacyRequired) {
        ddt.log('compliantlocalstorage', `allowed access to: ${key} because cookie privacy is not required in this region`);
        return true;
    }
    // allow all ESSENTIAL COOKIES
    if (cookieType === CompliantCategories.ESSENTIAL) {
        ddt.log('compliantlocalstorage', `allowed access to: ${key} because it is an ESSENTIAL cookie`);
        return true;
    }
    // only CompliantCategories.ESSENTIAL is allowed if user has not accepted cookies
    if (!hasAcceptedCookies) {
        ddt.log('compliantlocalstorage', `denying access to: ${key} because user has not accepted cookies`);
        return false;
    }
    if (acceptedCookieTypes[cookieType] === true) {
        ddt.log('compliantlocalstorage', `allowed access to: ${key} because user has accepted ${cookieType} cookies`);
        return true;
    }
    ddt.log('compliantlocalstorage', `key: ${key} is not a cookie type user has accepted`);
    return false;
};
// Storage event channel singleton: the initial self-call generates a
// channel, sunsequent calls to `getStorageEventChannel` fetch it
export const getStorageEventChannel = (()=>{
    const channel = multicastChannel();
    return ()=>{
        return channel;
    };
})();
